import React from "react"
import Banner from "../../containers/banner"
import About from "../../containers/about"
import Layout from "../../containers/layout";
import { Container, Row, Col } from 'reactstrap';
import { Titlespan2 } from '../../components/title/index';
import AfterBanner from '../../containers/after-banner';

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Industry Sectors" body={(
                <>
                    <h3>Artificial Intelligence</h3>
                    <p><a className="text-white" href="/sectors">Back to sectors</a></p>
                </>
            )}/>
            <AfterBanner size={9} title="" subtitle="Overview">
                <p>AI is where humans work with machines to enable far greater outcomes. Our teams with industry leaders to help advance AI innovation that can create growth and optimization strategies for your organization.</p>
                <p>We cooperate with businesses of all sizes, from startups to large enterprises. Our experience tells us that, regardless of the size of a company, business owners face similar challenges when planning new data initiatives. Our clients either don’t have their own data science teams, or their team is too small to cope with all the tasks in the environment of a fast-growing company.</p>
                <p>With us, you’ll save time on looking for top-notch specialists. Our team of world-class data scientists, AI consultants, and ML engineers will bring technical know-how to your project from day one.</p>
            </AfterBanner>
            <About width={8} title={'How we work'} body={(
                <div className="text-white">
                    <p className="text-white">Reviewing your current capabilities and defining future goals to make recommendations for tools, technology, and architecture.</p>
                    <p className="text-white">Improvement of previously built models to continuously raise the quality of insights and to keep up with the changing environment.</p>
                    <p className="text-white">Test a small-scale system, proving the viability of ML models for your problem.</p>
                    <p className="text-white">Put the ML system into production while considering implementation and maintenance costs during deployment.</p>

                </div>
            )} />

            <section className="text-left" >
                <Container>
                    <div className="main-title-wrapper text-left">
                    <Col xs={12} lg={{ size: 6}}>
                        <Titlespan2
                                Class="sitemain-subtitle"
                                Name="What we offer"
                                Label=""
                            />

                        <p>Custom-tailored AI solutions and services to help our clients to solve complex issues and add value to their business efficiency.</p>
                        
                        <ul>
                             <li>Data Science &amp; Analytics</li>
                            <li>Data Strategy</li>
                            <li>Business Intelligence</li>
                            <li>AI Software Development</li>
                            <li>Artificial Intelligence Consulting</li>
                            <li>Data Engineering &amp; Architecture</li>
                        </ul>
                    </Col>
                    </div>
                </Container>
            </section>
        </Layout>
    )
}

export default IndexPage
